const AydinlatmaMetniIsOrtagi = `
                <main class="legal-texts">
                    <h2>1. Amaç</h2>

                    <p>
                        Hangisi İnternet ve Bilgi Teknolojileri A.Ş. ("hangikredikobi.com" veya "Şirket"), gerçek kişi iş ortaklarına ait kişisel verilerin 6698 sayılı Kişisel Verilerin Korunması  Kanunu  ("KVK  Kanunu")  ve  sair  mevzuat hükümlerine  uygun şekilde işlenmesini amaçlamaktadır. Şirketimizin  gerçek kişi iş ortakçısı olmanız sebebiyle Şirketimize bildirdiğiniz/bildireceğiniz ve/veya Şirketimizce  haricen  herhangi  bir  yoldan temin edilen kişisel verileriniz Şirketimiz tarafından "Veri Sorumlusu" sıfatıyla,
                    </p>

                    <ul>
                        <li>Kişisel verilerinizi işlenmelerini gerektiren amaç çerçevesinde ve bu amaç ile bağlantılı, sınırlı ve ölçülü şekilde,</li>
                        <li>Şirketimize bildirdiğiniz veya bildirildiği şekliyle kişisel verilerin doğruluğunu ve en güncel halini koruyarak,</li>
                        <li>Kaydedileceğini, depolanacağını, muhafaza edileceğini, yeniden düzenleneceğini, kanunen bu kişisel verileri talep etmeye yetkili olan kurumlar ile paylaşılacağını ve KVK Kanunu’nun öngördüğü şartlarda, yurt içi veya yurt dışı üçüncü kişilere aktarılacağını, devredileceğini, sınıflandırılabileceğini ve KVK Kanunu’nda sayılan sair şekillerde işlenebileceğini ve KVK Kanunu’nda sayılan diğer işlemlere tabi tutulabileceğini bildiririz. </li>
                    </ul>

                    <p>Aydınlatma Metni ile hangikredikobi.com tarafından yürütülen faaliyetlerin KVK Kanunu’nda yer alan ilkelerle uyumlu olarak sürdürülmesi ve geliştirilmesi benimsenmiştir.</p>

                    <h2>2. Gerçek Kişi İş Ortaklarının Kişisel Verilerinin Toplanması ve Usulü</h2>

                    <p>Şirketimiz, kişisel verilerinizi işbu Aydınlatma Metni’nde belirtilen amaçlar doğrultusunda işleyecektir. Kişisel verilerinizin işlenme amacında herhangi bir değişiklik olması halinde tarafınızdan ayrıca izin alınacaktır. </p>

                    <p><em>Şirketimiz tarafından toplanan ve kullanılan, İş Ortaklarına ait kişisel veriler özellikle şunlardır:</em></p>

                    <div class="legal-text-table">
                        <table>
                            <tbody><tr>
                                <td></td>
                                <th>Kişisel Verinin İçeriği</th>
                            </tr>
                            <tr>
                                <th>Kimlik Verisi</th>
                                <td>Ad-soyad, T.C. kimlik numarası.</td>
                            </tr>
                            <tr>
                                <th>İletişim Verisi</th>
                                <td>Telefon numarası, ikametgah belgesi, adres, ülke, e-posta adresi (dâhili numarası ve kurumsal e-posta adresi dâhil)</td>
                            </tr>
                            <tr>
                                <th>Özlük Verisi</th>
                                <td>İlgilikişi görevi ve pozisyonu gibi bilgiler.</td>
                            </tr>
                            <tr>
                                <th>İş Ortağı İşlem Verisi</th>
                                <td>Adı soyadı, iletişim bilgileri, banka hesap bilgileri, vergi dairesi ve vergi numarası, çalışan sayısı, iş ortağı kategorisi, iş ortağından alınan ürün/hizmet, ticaret sicil numarası, sözleşme başlama ve bitiş tarihi gibi bilgiler.</td>
                            </tr>
                        </tbody></table>
                    </div>

                    <p>
                        Şirketimiz, hukuki yükümlülüklerini yerine getirmek, şirketinizle ve/veya sizinle, gerek sözleşme ilişkisinin kurulmasından önce gerekse sözleşme ilişkisinin kurulmasından sonra ve devamı boyunca Şirketimize ibraz etmiş olduğunuz verileri, fiziksel veya elektronik ortamda elde edilen her türlü bilgi belge ve doküman aracılığı ile ve kanunlarda öngörülen nedenlerle fiziksel veya elektronik ortamlar aracılığıyla toplamaktadır.
                    </p>

                    <h2>3. Kişisel Verilerin İşlenme Amaçları ve Hukuki Sebepler</h2>

                    <p>Kişisel Verileriniz, Şirketimiz tarafından aşağıda belirtilen amaçlar doğrultusunda ancak bunlarla sınırlı olmamak kaydıyla işlenebilir.</p>

                    <strong>Sözleşmenin kurulması ve ifası amacıyla, özellikle;</strong>

                    <ul>
                        <li>İş ortağı hizmetlerinin temini ve takibinin yapılması.</li>
                    </ul>

                    <p>Kişisel verileriniz, ilgili mevzuatta belirtilen veya işleme amacının ortadan kalmasına kadar geçecek olan makul süre ve herhalde kanuni zamanaşımı süreleri kadar muhafaza edilecektir.</p>

                    <h2>4. Kişisel Verilerin Güvenliğinin ve Gizliliğinin Sağlanması</h2>

                    <p>Şirketimiz, KVK Kanunu’nun 12. maddesine uygun olarak, işlemekte olduğu kişisel verilerin hukuka aykırı olarak işlenmesini ve kişisel verilere hukuka aykırı erişilmesini önlemek, kişisel verilerin muhafazasını sağlamak için uygun güvenlik düzeyini temin etmeye yönelik gerekli her türlü teknik ve idari tedbirleri almaktadır.</p>

                    <h2>4.1. Kişisel Verilerin Hukuka Uygun İşlenmesini Sağlamak ve Kişisel Verilere Hukuka Aykırı Erişimi Engellemek İçin Alınan İdari Tedbirler</h2>

                    <ul>
                        <li>KVK Kanunu’na ilişkin şirket çalışanlarının eğitilmesi ve bilinçlendirilmesi, </li>
                        <li>Kişisel veri aktarımının söz konusu olduğu durumlarda, kişisel verilerin aktarıldığı kişiler ile akdedilmiş sözleşmelere kişisel verilerin aktarıldığı tarafın veri güvenliğini yerine getireceğine ilişkin kayıt eklenmesinin sağlanması,</li>
                        <li>KVK Kanunu’na uyum için yerine getirilmesi gerekenlerin tespit edilmesi ve uygulamaları için iç politikaların hazırlanması, </li>
                    </ul>

                    <h2>4.2.Kişisel Verilerin Kanuni Olmayan Yollarla İfşası Durumunda Alınacak Tedbirler</h2>

                    <p>İşlenen kişisel verilerin kanuni olmayan yollarla başkaları tarafından elde edilmesi halinde, Şirketimiz bu durumu en kısa sürede ilgili kişiye ve Kurul’a bildirecektir.</p>

                    <h2>5. Kişisel Verilerin Silinmesi, Yok Edilmesi ve Anonim Hale Getirilmesi </h2>

                    <p>KVK Kanunu’nun 7. maddesi uyarınca, kişisel verilerin ilgili mevzuata uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin ortadan kalkması halinde kişisel veriler re’sen veya ilgili kişinin talebi üzerine Şirketimiz tarafından silinir, yok edilir veya anonim hale getirilir. Bu hususa ilişkin usul ve esaslar KVK Kanunu ve bu Kanun dayanak alınarak oluşturacak ikincil mevzuata göre yerine getirilecektir.</p>

                    <h2>6. İş Ortaklarının Sahip Olduğu Haklar</h2>

                    <p>KVK Kanunu’nun 11. maddesi uyarınca, Şirketimize başvurarak kişisel verileriniz hakkında aşağıdaki konulara ilişkin taleplerde bulunabilirsiniz:</p>

                    <ol>
                        <li>Kişisel verilerinin işlenip işlenmediğini öğrenme, </li>
                        <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme, </li>
                        <li>Kişisel verilerinin işlenme amacı ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme, </li>
                        <li>Kişisel verilerinin yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri öğrenme, </li>
                        <li>Kişisel verilerinin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme ve bu kapsamda
                        </li><li>yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme, </li>
                        <li>Kişisel verilerinin işlenmesini gerektiren sebeplerin ortadan kalkması halinde bunların silinmesini, yok edilmesini veya anonim hale getirilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
                        <li>İşlenen kişisel verilerinin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle ilgili kişinin aleyhine bir sonucun ortaya çıkmasına itiraz etme, </li>
                        <li>Kişisel verilerinin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması halinde zararın giderilmesini talep etme. </li>
                    </ol>

                    <p>Şirketimiz, KVK Kanunu’ndan doğan taleplerinizi "İlgili Kişi Başvuru Formu" aracılığıyla gerçekleştirecektir. Şirketimiz, KVK Kanunu’nun 13. maddesine uygun olarak, başvuru taleplerinizi, talebin niteliğine göre ve en geç 30 (otuz) gün içinde ücretsiz olarak sonuçlandıracaktır. Talebin reddedilmesi halinde, ret nedeni/nedenleri tarafınıza yazılı olarak veya elektronik ortamda gerekçeleriyle bildirilir. </p>

                    <p>İşbu Aydınlatma Metni, gerekli görüldüğü hallerde Şirketimiz tarafından revize edilebilir. Revizyonun söz konusu olduğu hallerde ise, bu hususa ilişkin olarak tarafınıza bilgilendirme yapılacaktır. </p>

                    <p>Aydınlatma Metni’nin en güncel haline <a href="https://www.hangikredikobi.com/kisisel-verilerin-korunmasi">kisisel-verilerin-korunmasi</a> linkinden ulaşabilirsiniz.</p>

                    <br>
                    <br>

                    <div class="legal-text-contact">
                        <strong>İLETİŞİM BİLGİLERİ</strong>

                        <address>
                            <strong>Hangisi İnternet ve Bilgi Hizmetleri A.Ş.</strong><br>
                             Anel İş Merkezi Yamanevler Mah. Site Yolu Cad. No:5/6 34768 Ümraniye/ İstanbul
                        </address>

                        <p>
                            <strong>E-posta: </strong><a href="mailto:kvkk@hangikredikobi.com">kvkk@hangikredikobi.com</a>
                        </p>

                        <p><strong>Web Sitesi:</strong> <a href="https://www.hangikredikobi.com/">https://www.hangikredikobi.com</a></p>

                        <p><strong>MERSİS NO:</strong> 0524052734800011</p>

                    </div>
                </main>
                              `;

export default AydinlatmaMetniIsOrtagi;
